export default "__VITE_ASSET__ZbdRN53B__"